/**
 * Search API helpers. Phase 4.
 */

export async function searchAll(query) {
  const params = new URLSearchParams({ q: query });
  const res = await fetch(`/api/search?${params}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Search failed');
  return res.json();
}

export async function searchUsers(query) {
  const params = new URLSearchParams({ q: query });
  const res = await fetch(`/api/search/users?${params}`, { credentials: 'include' });
  if (!res.ok) throw new Error('User search failed');
  return res.json();
}

export async function searchHashtags(query) {
  const params = new URLSearchParams({ q: query });
  const res = await fetch(`/api/search/hashtags?${params}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Hashtag search failed');
  return res.json();
}

export async function searchLocations(query) {
  const params = new URLSearchParams({ q: query });
  const url = `/api/search/locations?${params}`;
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) {
    throw new Error('Location search failed');
  }
  const data = await res.json();
  return data;
}
